import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Select, { components } from "react-select";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import MaterialReactTable from "material-react-table";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AdminHeaderNew from "../NewAdminPanel/Common/AdminHeader";
import AdminSideBarNew from "../NewAdminPanel/Common/AdminSideBar";
import AdminFooterNew from "../NewAdminPanel/Common/AdminFooter";
import { ExportToCsv } from "export-to-csv";
//import strict from "assert/strict";

const validSchemeCodesForSeedDemonstration = ["20", "9", "8", "5","15","46","48"];

const getFirstValue = (row, keys) => {
    for (const key of keys) {
        if (row && Object.prototype.hasOwnProperty.call(row, key)) {
            const value = row[key];
            if (value !== undefined && value !== null) {
                return value;
            }
        }
    }
    return "";
};

const getPrimaryInputDetails = (farmer) => {
    if (!farmer || !Array.isArray(farmer.inputDetails)) {
        return {};
    }
    return farmer.inputDetails[0] || {};
};

const SeedDemonstration = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState("");
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState("");
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState("");
    const [financialYearValue, setFinancialYearValue] = useState("All");
    const [demoTypeOptions, setDemoTypeOptions] = useState([]);
    const [demoTypeValue, setDemoTypeValue] = useState(null);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [infoMessage, setInfoMessage] = useState("");
    const [hasSearched, setHasSearched] = useState(false);
    const [header, setHeader] = useState("");
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [editCode, setEditCode] = useState({});
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const isSeedDemoScheme = validSchemeCodesForSeedDemonstration.includes(
        String(schemeCode)
    );

    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;

    useEffect(() => {
        if (!isSeedDemoScheme) {
            navigate("/newadminpanel/farmer");
        }
    }, [isSeedDemoScheme, navigate]);

    useEffect(() => {
        try {
            const navHeader = location?.state?.header
                ? String(location.state.header)
                : "";
            const storedHeader = sessionStorage.getItem("farmerHeader") || "";
            const nextHeader = navHeader || storedHeader || "Seed Demonstration";
            setHeader(nextHeader);

            if (navHeader) {
                sessionStorage.setItem("farmerHeader", navHeader);
            }
        } catch (_) {
            // ignore storage issues
        }
    }, [location]);

    useEffect(() => {
        getStates();
    }, []);

    useEffect(() => {
        fetchDemoTypeOptions();
    }, []);

    const getStates = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        };

        fetch(`${baseUrl}/api/states`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataState = JSON.parse(result).dataContent || [];
                const myArray = localFormDataState.map((item) => ({
                    value: item.stateCode,
                    label: item.stateName,
                }));
                setOptionState(myArray);

                const userType = sessionStorage.getItem("userTypeCodeModel");
                const userTypeValue = Number(userType);
                const userTypeCode = Number.isNaN(userTypeValue) ? 0 : userTypeValue;
                const stateCode = sessionStorage.getItem("stateNameModel");
                const districtCode = sessionStorage.getItem("districtNameModel");

                if (
                    userTypeCode >= 2 &&
                    stateCode &&
                    stateCode !== "null"
                ) {
                    const matchingState = myArray.find(
                        (state) => String(state.value) === String(stateCode)
                    );
                    const nextStateCode = matchingState
                        ? matchingState.value
                        : stateCode;
                    setStateValue([nextStateCode]);
                    setIsStateDisabled(true);
                    handleState(nextStateCode, userTypeCode >= 3 ? districtCode : "");
                } else {
                    setIsStateDisabled(false);
                    setIsDistrictDisabled(false);
                }
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    };

    const fetchDemoTypeOptions = async () => {
        try {
            const { data } = await axios.get(
                `${baseUrl}/api/Demonstration/GetDemonstrationTypeDropdown`,
                {
                    headers: {
                        accept: "*/*",
                    },
                }
            );
            if (data?.success && Array.isArray(data.dataContent)) {
                const options = data.dataContent.map((item) => ({
                    value: item.typeId,
                    label: item.typeName,
                }));
                setDemoTypeOptions(options);
            } else {
                setDemoTypeOptions([]);
            }
        } catch (error) {
            console.error("Error fetching demonstration types:", error);
            setDemoTypeOptions([]);
        }
    };


    useEffect(() => {
        if (demoTypeOptions.length > 0 && demoTypeValue === null) {
            const defaultOption =
                demoTypeOptions.find((option) => Number(option.value) === 1) ||
                demoTypeOptions[0];
            if (defaultOption) {
                setDemoTypeValue(defaultOption.value);
            }
        }
    }, [demoTypeOptions, demoTypeValue]);

    const handleState = (stateCodeParam = "", districtCodeParam = "") => {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        setOptionDistrict([]);
        setDistrictValue("");
        setIsDistrictDisabled(false);
        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");

        if (!currentStateValue || currentStateValue.length === 0) {
            return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const stateValueData = currentStateValue.join(",");
        const raw = JSON.stringify({
            stateCode: stateValueData.toString(),
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw,
        };

        fetch(`${baseUrl}/api/district`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataDistrict = JSON.parse(result).dataContent || [];
                const myArrayDistrict = localFormDataDistrict.map((item) => ({
                    label: item.districtName,
                    value: item.districtCode,
                    stateid: item.stateCode,
                }));

                setOptionDistrict(myArrayDistrict);

                if (districtCodeParam && districtCodeParam !== "null") {
                    const districtOption = myArrayDistrict.find(
                        (district) =>
                            String(district.value) === String(districtCodeParam)
                    );
                    if (districtOption) {
                        setDistrictValue(districtOption.value);
                        setIsDistrictDisabled(true);
                        handleChangeDistrict(districtOption);
                    }
                }
            })
            .catch((error) => console.error("Error fetching districts:", error));
    };

    const handleChange = (selectedOption) => {
        const nextValue = selectedOption ? [selectedOption.value] : [];
        setStateValue(nextValue);
        setfarmerData([]);
        setErrorMessage("");
        setInfoMessage("");
        setHasSearched(false);

        setOptionDistrict([]);
        setDistrictValue("");
        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");
        setIsDistrictDisabled(false);

        if (!selectedOption) {
            return;
        }

        handleState(selectedOption.value);
    };

    const handleChangeDistrict = (selectedOption) => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const userTypeValue = Number(userType);
        const userTypeCode = Number.isNaN(userTypeValue) ? 0 : userTypeValue;
        if (
            userTypeCode >= 3 &&
            districtValue &&
            (!selectedOption || String(selectedOption.value) !== String(districtValue))
        ) {
            return;
        }

        setOptionSubDistrict([]);
        setsubDistrictValue("");
        setOptionVillage([]);
        setvillageValue("");

        if (!selectedOption) {
            setDistrictValue("");
            return;
        }

        setDistrictValue(selectedOption.value);
        const stateValueData = selectedOption.stateid || stateValue[0];

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            blockCode: 0,
            blockName: "",
            subDistrictCode: 0,
            districtCode: Number(selectedOption.value),
            visibility: 1,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw,
        };

        fetch(`${baseUrl}/api/block`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataBlock = JSON.parse(result).dataContent || [];
                const myArrayBlock = localFormDataBlock.map((item) => ({
                    label: item.blockName,
                    value: item.blockCode,
                }));
                setOptionSubDistrict(myArrayBlock);
            })
            .catch((error) =>
                console.error("Error fetching blocks:", error)
            );
    };

    const handleChangeSubDistrict = (selectedOption) => {
        setvillageValue("");
        setOptionVillage([]);

        if (!selectedOption) {
            setsubDistrictValue("");
            return;
        }

        setsubDistrictValue(selectedOption.value);

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
            blockcode: selectedOption.value,
            districtcode: districtValue || 0,
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw,
        };

        fetch(`${baseUrl}/api/village`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                const localFormDataVillage = JSON.parse(result).dataContent || [];
                const myArrayVillage = localFormDataVillage.map((item) => ({
                    label: item.villageName,
                    value: item.villageCode,
                    subDistrictCode: item.subDistrictCode,
                }));
                setOptionVillage(myArrayVillage);
            })
            .catch((error) => console.log("Error fetching villages:", error));
    };

    const handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
        } else {
            setvillageValue("");
        }
    };

    const fetchDataFilterWise = async () => {
        if (!isSeedDemoScheme) {
            return;
        }

        setLoaderFarmer(true);
        setIsFetching(true);
        setfarmerData([]);
        setInfoMessage("");

        const toNumber = (value) => {
            const parsed = Number(value);
            return Number.isNaN(parsed) ? 0 : parsed;
        };

        const stateValueData = toNumber(stateValue?.[0] || 0);
        const districtValueData = toNumber(districtValue || 0);
        const subdistrictValueData = toNumber(subdistrictValue || 0);
        const villageValueData = toNumber(villageValue || 0);

        try {
            const result = await axios.post(
                `${baseUrl}/api/Demonstration/getDemonstrationFarmerWiseDetails`,
                {
                    schemeCode: toNumber(schemeCode || 0),
                    stateCode: stateValueData,
                    districtCode: districtValueData,
                    subDistrictCode: subdistrictValueData,
                    blockCode: subdistrictValueData,
                    villageCode: villageValueData,
                    cropGroupCode: "",
                    cropCode: "",
                    finYear:
                        financialYearValue && financialYearValue !== "All"
                            ? financialYearValue
                            : "",
                    demoType: String(Number(demoTypeValue) || 1),
                    sortField: "",
                    pageNumber: 1,
                    pageSize: 1000,
                    farmerMobile: "",
                    cropDemonstrationCode: "",
                }
            );

            if (result?.data?.success) {
                const data = Array.isArray(result.data.dataContent)
                    ? result.data.dataContent
                    : [];
                setfarmerData(data);
                setInfoMessage(
                    data.length === 0 ? "No data found for the selected filters." : ""
                );
                setErrorMessage("");
            } else {
                setfarmerData([]);
                setInfoMessage("No data found for the selected filters.");
                setErrorMessage("");
            }
        } catch (error) {
            console.error("Error fetching seed demonstration data:", error);
            setfarmerData([]);
            setInfoMessage("Unable to fetch data. Please try again.");
            setErrorMessage("");
        } finally {
            setIsFetching(false);
            setLoaderFarmer(false);
        }
    };

    const clearSearch = () => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const userTypeValue = Number(userType);
        const userTypeCode = Number.isNaN(userTypeValue) ? 0 : userTypeValue;
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = sessionStorage.getItem("districtNameModel");

        setfarmerData([]);
        setErrorMessage("");
        setOptionDistrict([]);
        setOptionSubDistrict([]);
        setOptionVillage([]);
        setDistrictValue("");
        setsubDistrictValue("");
        setvillageValue("");
        setFinancialYearValue("All");
        setDemoTypeValue(null);
        setIsDistrictDisabled(false);
        setEditCode({});
        if (
            userTypeCode >= 2 &&
            stateCode &&
            stateCode !== "null"
        ) {
            setStateValue([stateCode]);
            setIsStateDisabled(true);
            handleState(stateCode, userTypeCode >= 3 ? districtCode : "");
            return;
        }

        setStateValue([]);
        setIsStateDisabled(false);
    };

    const ValidateAddUser = () => {
        if (!stateValue || stateValue.length === 0) {
            setErrorMessage("Please select a State.");
            return;
        }

        setErrorMessage("");
        setInfoMessage("");
        setHasSearched(true);
        fetchDataFilterWise();
    };

    const handleExportData = () => {
        const flattenObject = (obj, parentKey = "", result = {}) => {
            for (let key in obj) {
                if (!obj.hasOwnProperty(key)) continue;
                const fullKey = parentKey ? `${parentKey}.${key}` : key;

                if (
                    Array.isArray(obj[key]) &&
                    obj[key].length > 0 &&
                    typeof obj[key][0] === "object"
                ) {
                    flattenObject(obj[key][0], "", result);
                } else if (typeof obj[key] === "object" && obj[key] !== null) {
                    flattenObject(obj[key], fullKey, result);
                } else {
                    result[key] = obj[key];
                }
            }
            return result;
        };

        let exportData = farmerData?.map((item) => {
            const flattened = flattenObject(item);
            flattened.totalFarmers = Array.isArray(item?.farmers)
                ? item.farmers.length
                : 0;
            return flattened;
        });

        const allKeys = new Set();
        exportData.forEach((row) => {
            Object.keys(row).forEach((key) => allKeys.add(key));
        });

        const headers = Array.from(allKeys);

        const result = exportData.map((item) => {
            const row = {};
            headers.forEach((key) => {
                row[key] = item[key] ?? "";
            });
            return row;
        });

        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: headers,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
    };

    const handleExportFarmerWiseReport = async () => {
        const toNullableNumber = (value) => {
            const parsed = Number(value);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const stateCodeValue = stateValue?.[0]
            ? toNullableNumber(stateValue[0])
            : null;
        const districtCodeValue = districtValue
            ? toNullableNumber(districtValue)
            : null;
        const subDistrictCodeValue = subdistrictValue
            ? toNullableNumber(subdistrictValue)
            : null;
        const villageCodeValue = villageValue ? toNullableNumber(villageValue) : null;
        const demoTypeCode = demoTypeValue ? Number(demoTypeValue) : 1;
        const finYearValue =
            financialYearValue && financialYearValue !== "All"
                ? financialYearValue
                : null;

        setLoaderFarmer(true);
        try {
            const result = await axios.post(
                `${baseUrl}/api/Demonstration/getDemonstrationReport`,
                {
                    schemeCode: toNullableNumber(schemeCode) || 0,
                    stateCode: stateCodeValue,
                    districtCode: districtCodeValue,
                    subDistrictCode: subDistrictCodeValue,
                    blockCode: subDistrictCodeValue,
                    villageCode: villageCodeValue,
                    demoType: demoTypeCode,
                    finYear: finYearValue,
                    sortField: null,
                    pageNumber: 1,
                    pageSize: 1000,
                    farmerMobile: null,
                    cropDemonstrationCode: null,
                }
            );

            const rows = Array.isArray(result?.data?.dataContent)
                ? result.data.dataContent
                : [];

            if (!result?.data?.success || rows.length === 0) {
                alert("No data found for farmer wise report.");
                return;
            }

            const headers = [];
            const headerSet = new Set();
            rows.forEach((row) => {
                Object.keys(row || {}).forEach((key) => {
                    if (!headerSet.has(key)) {
                        headerSet.add(key);
                        headers.push(key);
                    }
                });
            });

            const exportRows = rows.map((row) => {
                const data = {};
                headers.forEach((key) => {
                    data[key] = row?.[key] ?? "";
                });
                return data;
            });

            const csvOptions = {
                fieldSeparator: ",",
                quoteStrings: '"',
                decimalSeparator: ".",
                showLabels: true,
                useBom: true,
                useKeysAsHeaders: false,
                headers: headers,
                filename: "farmer-wise-report",
            };

            const csvExporter = new ExportToCsv(csvOptions);
            csvExporter.generateCsv(exportRows);
        } catch (error) {
            console.error("Error exporting farmer wise report:", error);
            alert("Failed to export farmer wise report.");
        } finally {
            setLoaderFarmer(false);
        }
    };
function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }
    const columns = useMemo(
        () => [
            {
                header: "S.No",
                size: 40,
                Cell: ({ row }) => row.index + 1,
            },
            {
                header: "Financial Year",
                accessorKey: "financialYear",
            },
            {
                header: "Demo Type",
                accessorKey: "demoType",
            },
            {
                header: "Demo Area (Ha)",
                id: "demoArea",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "demoAreaIn_HA",
                        "demoArea",
                    ]),
            },
            {
                header: "Crop Group",
                id: "cropGroup",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "cropGroup",
                        "cropGroupName",
                    ]),
            },
            {
                header: "Crop",
                id: "crop",
                accessorFn: (row) =>
                    getFirstValue(row, ["crop", "cropName"]),
            },
            {
                header: "Crop Variety",
                id: "cropVariety",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "cropVarietyName",
                    ]),
            },
            {
                header: "Period of Release",
                id: "periodOfRelease",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "periodOfRelease",
                        "releaseYear",
                    ]),
            },
            {
                header: "Variety Characteristics",
                id: "varietyCharacteristics",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "varietyCharacteristics",
                        "varietalCharName",
                        "otherVarietalCharName",
                    ]),
            },
            {
                header: "Season",
                id: "season",
                accessorFn: (row) =>
                    getFirstValue(row, ["seasonName", "season"]),
            },
            {
                header: "District",
                id: "district",
                accessorFn: (row) =>
                    getFirstValue(row, ["districtName", "district"]),
            },
            {
                header: "Block",
                id: "block",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "blockName",
                        "block",
                    ]),
            },
            {
                header: "Village",
                id: "village",
                accessorFn: (row) =>
                    getFirstValue(row, ["villageName", "village"]),
            },
            {
                header: "Demonstration No",
                id: "demonstrationNo",
                accessorFn: (row) =>
                    getFirstValue(row, [
                        "cropDemonstrationCode",
                        "demonstrationNo",
                    ]),
            },
            {
                header: "Total Farmers",
                id: "totalFarmers",
                accessorFn: (row) =>
                    Array.isArray(row?.farmers) ? row.farmers.length : 0,
            },
        ],
        []
    );

    const hasStateSelected = Array.isArray(stateValue) && stateValue.length > 0;
    const hasDistrictSelected = Boolean(districtValue);
    const hasBlockSelected = Boolean(subdistrictValue);

    const financialYearOptions = useMemo(() => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth();
        const fyStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
        const options = [{ value: "All", label: "All" }];

        for (let i = 0; i < 5; i += 1) {
            const startYear = fyStartYear - i;
            const endYear = startYear + 1;
            const label = `${startYear}-${endYear}`;
            options.push({ value: label, label });
        }

        return options;
    }, []);
   
    const renderDetailPanel = ({ row }) => {
        const farmers = Array.isArray(row?.original?.farmers)
            ? row.original.farmers
            : [];
        if (farmers.length === 0) {
            return null;
        }

        const formatQuantityUnit = (quantity, unit) => {
            if (quantity === null || quantity === undefined || quantity === "") {
                return unit ? String(unit) : "";
            }
            if (unit === null || unit === undefined || unit === "") {
                return String(quantity);
            }
            return `${quantity} ${unit}`;
        };

        return (
            <div className="table-responsive mt-2">
                <table className="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th>S. No</th>
                            <th>View Details</th>
                            <th>Farmer Name</th>
                            <th>Mobile No</th>
                            <th>Khasra No</th>
                            <th>Input Type 1 Name</th>
                            <th>Input Type 1 Quantity / Unit</th>
                            <th>Input Type 2 Name</th>
                            <th>Input Type 2 Quantity / Unit</th>
                            <th>Input Type 3 Name</th>
                            <th>Input Type 3 Quantity / Unit</th>
                            <th>Demonstration Area</th>
                        </tr>
                    </thead>
                    <tbody>
                        {farmers.map((farmer, index) => {
                            const inputDetails = getPrimaryInputDetails(farmer);
                            const input1 = formatQuantityUnit(
                                inputDetails?.quantity1,
                                inputDetails?.unit1
                            );
                            const input2 = formatQuantityUnit(
                                inputDetails?.quantity2,
                                inputDetails?.unit2
                            );
                            const input3 = formatQuantityUnit(
                                inputDetails?.quantity3,
                                inputDetails?.unit3
                            );
                            const demonstrationArea =
                                getFirstValue(farmer, [
                                    "areaUnderDemonstration",
                                ]) ||
                                getFirstValue(row?.original, ["demoAreaIn_HA"]);
                            return (
                                <tr key={farmer?.beneficiaryCodeM || index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <button
                                            className="btn"
                                            type="button"
                                            onClick={() => navigateData(farmer)}
                                        >
                                            <i><FontAwesomeIcon icon={faEye} /></i>
                                        </button>
                                    </td>
                                    <td>{farmer?.farmerName || ""}</td>
                                    <td>{farmer?.mobileNo || ""}</td>
                                    <td>{farmer?.khasraNo || ""}</td>
                                    <td>{inputDetails?.inputName1 || ""}</td>
                                    <td>{input1}</td>
                                    <td>{inputDetails?.inputName2 || ""}</td>
                                    <td>{input2}</td>
                                    <td>{inputDetails?.inputName3 || ""}</td>
                                    <td>{input3}</td>
                                    <td>{demonstrationArea}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };

    if (!isSeedDemoScheme) {
        return null;
    }

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew setHeader={setHeader} />

            <main id="main" className="main" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 60px)', overflow: 'hidden' }}>
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between" style={{ flexShrink: 0 }}>
                    <nav>
                        <h1>Seed Demonstration List - {header}</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Seed Demonstration List</li>
                            <li className="breadcrumb-item active">Seed Demonstration</li>
                        </ol>
                    </nav>
                </div>

                <section className="section" style={{ flexShrink: 0 }}>
                    <div className="row surveydetailsBg">
                        <div className="col-md-2">
                            <label htmlFor="State" className="form-label">
                                State
                            </label>
                            <label style={{ color: "red" }}>*</label>
                            <Select
                                options={optionState}
                                value={
                                    stateValue && stateValue.length > 0
                                        ? optionState.find(
                                              (option) =>
                                                  String(option.value) ===
                                                  String(stateValue[0])
                                          )
                                        : null
                                }
                                onChange={handleChange}
                                isClearable={!isStateDisabled}
                                isSearchable={true}
                                isDisabled={isStateDisabled}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select State"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-2">
                            <label htmlFor="District" className="form-label">
                                District
                            </label>
                            <Select
                                options={hasStateSelected ? optionDistrict : []}
                                value={
                                    hasStateSelected
                                        ? optionDistrict.find(
                                              (option) =>
                                                  String(option.value) ===
                                                  String(districtValue)
                                          )
                                        : null
                                }
                                onChange={handleChangeDistrict}
                                isClearable={!isDistrictDisabled}
                                isSearchable={true}
                                isDisabled={isDistrictDisabled}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select District"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-2">
                            <label htmlFor="Block" className="form-label">
                                Block
                            </label>
                            <Select
                                options={hasDistrictSelected ? optionSubDistrict : []}
                                value={
                                    hasDistrictSelected
                                        ? optionSubDistrict.find(
                                              (option) =>
                                                  String(option.value) ===
                                                  String(subdistrictValue)
                                          )
                                        : null
                                }
                                onChange={handleChangeSubDistrict}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Block"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-2">
                            <label htmlFor="Village" className="form-label">
                                Village
                            </label>
                            <Select
                                options={hasBlockSelected ? optionVillage : []}
                                value={
                                    hasBlockSelected
                                        ? optionVillage.find(
                                              (option) =>
                                                  String(option.value) ===
                                                  String(villageValue)
                                          )
                                        : null
                                }
                                onChange={handleChangeVillage}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Village"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>
                        <div className="col-md-2">
                            <label htmlFor="financialYear" className="form-label">
                                Financial Year
                            </label>
                            <Select
                                options={financialYearOptions}
                                value={
                                    financialYearOptions.find(
                                        (option) => option.value === financialYearValue
                                    ) || financialYearOptions[0]
                                }
                                onChange={(selectedOption) =>
                                    setFinancialYearValue(
                                        selectedOption ? selectedOption.value : ""
                                    )
                                }
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Financial Year"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>
                        <div className="col-md-2">
                            <label htmlFor="demoType" className="form-label">
                                Demo Type
                            </label>
                            <Select
                                options={demoTypeOptions}
                                value={demoTypeOptions.find(
                                    (option) => option.value === demoTypeValue
                                )}
                                onChange={(selectedOption) =>
                                    setDemoTypeValue(
                                        selectedOption ? selectedOption.value : null
                                    )
                                }
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Demo Type"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>
                                            {children}
                                        </components.Option>
                                    ),
                                }}
                            />
                        </div>

                        <div className="col-md-12 d-flex justify-content-md-center mt-3">
                            <button
                                type="button"
                                className="btn btn-primary farmrbtn me-md-2"
                                onClick={ValidateAddUser}
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                className="btn btn-success me-md-2"
                                onClick={clearSearch}
                            >
                                Clear
                            </button>
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    {!errorMessage && infoMessage && hasSearched && !isFetching && (
                        <div className="alert alert-info" role="alert">
                            {infoMessage}
                        </div>
                    )}
                </section>

                <section className="section" style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
                    {farmerData.length > 0 ? (
                        <div className="row justify-content-lg-center">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body" style={{ padding: '20px' }}>
                                        <MaterialReactTable
                                            columns={columns}
                                            data={farmerData}
                                            enableColumnOrdering
                                            enablePagination={true}
                                            enableExpandAll={false}
                                            enableStickyHeader
                                            state={{ isLoading: isFetching }}
                                            muiTableContainerProps={{
                                                sx: {
                                                    maxHeight: '800px',
                                                    overflowY: 'auto',
                                                    overflowX: 'auto',
                                                    '&::-webkit-scrollbar': {
                                                        width: '8px',
                                                        height: '10px'
                                                    },
                                                    '&::-webkit-scrollbar-track': {
                                                        background: '#f1f1f1',
                                                        borderRadius: '10px'
                                                    },
                                                    '&::-webkit-scrollbar-thumb': {
                                                        background: '#888',
                                                        borderRadius: '10px'
                                                    },
                                                    '&::-webkit-scrollbar-thumb:hover': {
                                                        background: '#555'
                                                    }
                                                }
                                            }}
                                        renderTopToolbarCustomActions={() => (
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    gap: "1rem",
                                                    p: "0.5rem",
                                                    flexWrap: "wrap",
                                                }}
                                            >
                                                <Button
                                                    color="primary"
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                                <Button
                                                    color="secondary"
                                                    onClick={handleExportFarmerWiseReport}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Farmer wise Report
                                                </Button>
                                            </Box>
                                        )}
                                        renderDetailPanel={renderDetailPanel}
                                        muiExpandButtonProps={({ row, table }) => ({
                                            children: row.getIsExpanded()
                                                ? "-"
                                                : "+",
                                            disabled: !row.original?.farmers?.length,
                                            onClick: (event) => {
                                                event.stopPropagation();
                                                const isExpanded = row.getIsExpanded();
                                                table.setExpanded(
                                                    isExpanded ? {} : { [row.id]: true }
                                                );
                                            },
                                            sx: {
                                                fontSize: "2rem",
                                                fontWeight: 700,
                                            },
                                        })}
                                    />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </section>

                {LoaderFarmer ? (
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content">
                                <span className="spinner"></span>
                            </div>
                        </div>
                    </div>
                ) : null}
            </main>

            <AdminFooterNew />
        </>
    );
};

export default SeedDemonstration;
